// Honest ComingSoon for the live-document outline (plan §2, option a).
//
// The mockup rendered an OUTLINE_FIXTURES tree + cursor-nav carets + a
// "+ Section" button. NONE of that ships here: reading the Word doc's live
// outline needs an Office.js heading-scan adapter (`Word.run` →
// `paragraphs.load('text,styleBuiltIn')` → Heading1-N tree) + cursor-nav
// (`range.select`) — a W2 adapter that does not exist and needs a real-Word
// smoke to verify `styleBuiltIn` enumerates in the WebView. Rather than fake it
// with fixtures (anti-fake guard), this is an explicit, honest placeholder.
// Deferred to F-PLAN-OUTLINE.
//
// This is a thin LOCAL block (NOT the shell `<ComingSoon>`), because the shell
// component is a full-pane centered empty-state keyed by TabId; here we need a
// small sub-section header inside the Plan pane. CLAUDE.md §9: logical
// utilities only, all strings via `t('plan.outline.*')`.

import { useTranslation } from 'react-i18next'

export function OutlineComingSoon(): JSX.Element {
  const { t } = useTranslation()
  return (
    <div
      data-testid="plan-outline-coming-soon"
      className="flex flex-1 flex-col px-3.5 py-3"
    >
      <div className="mb-3 text-[10px] font-bold uppercase tracking-wider text-ink/40">
        {t('plan.outline.header')}
      </div>
      <div className="flex flex-1 flex-col items-center justify-center gap-2 px-4 py-8 text-center">
        <div className="font-serif text-sm font-semibold text-ink">
          {t('plan.outline.comingSoonTitle')}
        </div>
        <p className="max-w-[240px] text-xs leading-relaxed text-ink/60">
          {t('plan.outline.comingSoonBody')}
        </p>
      </div>
    </div>
  )
}
